// ============================================================
// AntD 主题 —— 把 design token 映射到 ConfigProvider。
// 清亮松绿风:主操作用松绿,标题/图标用墨蓝灰。
// ============================================================
import type { ThemeConfig } from 'antd';
import { brand, accent, neutral, radius, fontSize } from './tokens';

const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: accent[700], // 主操作 —— 松绿
    colorInfo: accent[700],
    colorSuccess: '#15803d',
    colorWarning: '#b45309',
    colorError: '#b91c1c',
    colorLink: accent[700],
    colorLinkHover: accent[600],

    colorText: neutral[800],
    colorTextSecondary: neutral[500],
    colorTextTertiary: neutral[400],
    colorBorder: neutral[200],
    colorBorderSecondary: neutral[100],
    colorBgLayout: '#f8faf9',
    colorBgContainer: neutral[0],

    borderRadius: radius.md,
    borderRadiusLG: radius.lg,
    borderRadiusSM: radius.sm,

    fontSize: fontSize.base,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', 'Segoe UI', sans-serif",

    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,

    boxShadow:
      '0 2px 8px rgba(15, 23, 42, 0.05), 0 4px 16px rgba(15, 23, 42, 0.04)',
    boxShadowSecondary:
      '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.05)',
  },
  components: {
    Button: {
      primaryShadow: '0 4px 12px rgba(15, 118, 110, 0.22)',
      fontWeight: 500,
      defaultBorderColor: neutral[200],
    },
    Card: {
      borderRadiusLG: radius.lg,
      boxShadowTertiary:
        '0 2px 8px rgba(15, 23, 42, 0.05), 0 4px 16px rgba(15, 23, 42, 0.04)',
      headerFontSize: fontSize.md,
      paddingLG: 24,
    },
    Menu: {
      itemBorderRadius: radius.sm,
      itemSelectedBg: accent[50],
      itemSelectedColor: accent[700],
      itemActiveBg: accent[50],
      itemHoverColor: accent[700],
      iconSize: 18,
    },
    Input: {
      activeShadow: `0 0 0 3px ${accent[100]}`,
      hoverBorderColor: accent[400],
      activeBorderColor: accent[600],
    },
    Tag: {
      borderRadiusSM: radius.sm,
      defaultBg: neutral[100],
    },
    Table: {
      headerBg: neutral[50],
      headerColor: neutral[600],
      borderColor: neutral[100],
      rowHoverBg: accent[50],
      headerBorderRadius: radius.md,
    },
    Progress: {
      defaultColor: accent[600],
    },
    Segmented: {
      itemSelectedBg: accent[700],
      itemSelectedColor: neutral[0],
      trackBg: neutral[100],
    },
    Tabs: {
      inkBarColor: accent[600],
      itemSelectedColor: accent[700],
      itemHoverColor: accent[600],
      titleFontSize: fontSize.base,
    },
    Badge: {
      colorError: accent[700],
    },
  },
};

export default antdTheme;
